import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SignUpPage from "./components/SignUpPage";
import LoginPage from "./components/LoginPage";
import MainPage from "./components/MainPage";
import Sidebar from "./components/Sidebar";
import Locations from "./components/Locations";
import QRpage from "./components/QRpage";
import PrivateRoute from "./services/PrivateRoute";
import LoadingIcon from "./components/items/LoadingIcon";
import Logout from "./components/Logout";
import { AuthProvider } from "./components/items/AuthProvider";
import OrderPage from "./components/OrderPage";
import RouteUI from "./components/Machines/RouteUI";
import { Helmet } from "react-helmet";
import GiftCardPage from "./components/GiftCardPage";
import ResetPassword from "./components/ResetPassword";
import ResetPassword2 from "./components/ResetPassword2";
import PendingOrder from "./components/PendingOrder";

const App = () => {
  useEffect(() => {
    console.log("updateing user");
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="">
          <Helmet>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
          </Helmet>
          <Sidebar className="" />
          <LoadingIcon />
          <Routes>
            <Route path="/signup/:company" element={<SignUpPage />} />
            <Route path="/login/:company" element={<LoginPage />} />
            <Route path="/resetpassword/:company" element={<ResetPassword />} />
            <Route
              path="/resetpassword2/:token/:company"
              element={<ResetPassword2 />}
            />
            <Route path="/logout" element={<Logout />} />
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Locations />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/giftcard" element={<GiftCardPage />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/pendingorder" element={<PendingOrder />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/orders" element={<OrderPage />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/locations" element={<Locations />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/QRcode" element={<QRpage />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/machineUI/*" element={<RouteUI />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};
export default App;
